import { buildProps } from '@pit-element-plus/utils'

import type { ExtractPublicPropTypes } from 'vue'
import type Row from './row.vue'

export const RowJustify = [
  'start',
  'center',
  'end',
  'space-around',
  'space-between',
  'space-evenly',
] as const

export const RowAlign = ['top', 'middle', 'bottom'] as const

export interface RowProps {
  /**
   * @description custom element tag
   */
  tag?: string
  /**
   * @description grid spacing
   */
  gutter?: number
  /**
   * @description horizontal alignment of flex layout
   */
  justify?: (typeof RowJustify)[number]
  /**
   * @description vertical alignment of flex layout
   */
  align?: (typeof RowAlign)[number]
}

/**
 * @deprecated Removed after 3.0.0, Use `RowProps` instead.
 */
export const rowProps = buildProps({
  /**
   * @description custom element tag
   */
  tag: {
    type: String,
    default: 'div',
  },
  /**
   * @description grid spacing
   */
  gutter: {
    type: Number,
    default: 0,
  },
  /**
   * @description horizontal alignment of flex layout
   */
  justify: {
    type: String,
    values: RowJustify,
    default: 'start',
  },
  /**
   * @description vertical alignment of flex layout
   */
  align: {
    type: String,
    values: RowAlign,
  },
} as const)

/**
 * @deprecated Removed after 3.0.0, Use `RowProps` instead.
 */
export type RowPropsPublic = ExtractPublicPropTypes<typeof rowProps>
export type RowInstance = InstanceType<typeof Row> & unknown
